var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconModalClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 9 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.707 4.293 8.071.929 7.364.222 4 3.586.707.293 0 1l3.293 3.293-3 3L1 8l3-3 3.071 3.07.707-.706-3.07-3.071Z",
  fill: "currentColor"
})));

export default SvgIconModalClose;